<div class="accordion-container" [ngClass]="[step.isListItemOpened ? 'open' :'']"
  *ngFor="let step of subSectionSteps; let i = index">
  <form #stepsForm="ngForm" autocomplete="off" novalidate>
    <ion-item [ngClass]="[step.compliance && step.compliance ==='notApplicable'?'div-background-green' : '',step.compliance && step.compliance ==='yesCompliant'?'div-background-green' : '',(step.compliance==='hazard' && (step.hasOwnProperty('hazardCount')&&(step.hazardCount==0)||(step.hasOwnProperty('hazardDetailsArray')&&step?.hazardDetailsArray?.length==0)))?'div-background-yellow' :(step.compliance==='hazard' && ((step.hasOwnProperty('hazardCount')&&step.hazardCount!=0)||(step.hasOwnProperty('hazardDetailsArray')&&step?.hazardDetailsArray?.length!=0)))? 'div-background-green':(step.compliance==='hazard' && ((!step.hasOwnProperty('hazardCount'))||(!step.hasOwnProperty('hazardDetailsArray'))))? 'div-background-yellow':'']" class="ion-item-css" lines="none" >
      <ion-label>{{step.stepBody || 'Add A Question' | translate}}</ion-label>
      <span *ngIf="step?.compliance==='hazard'"> {{ 'No. Of Hazards' | translate}}-{{step.hazardCount}}</span>
      <span *ngIf="step?.compliance !=='hazard'">{{(step?.compliance==="yesCompliant")?"Yes, Compliant":(step?.compliance==="notApplicable")?"Not applicable":'' | translate}}</span>
      <ion-icon style="font-size: 20px;padding: 8px;" *ngIf="!this.isRiskReassessment || this.roadmapStatus !=='Completed'" (click)="deleteStep(step,i)"
        class="trash-icon delete-icon-transition" name="trash-outline" tooltip="{{'Delete Step'  | translate }}" placement="bottom"></ion-icon>
      <ion-icon [name]="!step.isListItemOpened ? 'chevron-down-outline' : 'chevron-up-outline'"  (click)="toggleAccordion(step, i, subSectionSteps)"> </ion-icon>
    </ion-item>
    <div class="content">
      <div class="question-container" *ngIf="isCustom">
        <ion-label> {{ 'Question' | translate}} *</ion-label>
        <ion-item lines=none>
          <ion-textarea [autoGrow]="true" #questionTextArea [disabled]=" this.isRiskReassessment" [(ngModel)]="step.stepBody" name="stepBody" required #stepBody="ngModel"
            placeholder="{{'Add a Question'|translate}}" ></ion-textarea>
        </ion-item>
        <ion-text style="font-size: x-small; font-weight: bold" *ngIf="stepBody.invalid && stepBody.touched"
          color="danger">
          Required
        </ion-text>
      </div>

      <div class="question-container">
        <ion-label> {{ 'Notes' | translate}}</ion-label>
        <ion-item lines=none>
          <ion-textarea [autoGrow]="true" [disabled]=" this.isRiskReassessment" [(ngModel)]="step.stepNote" name="stepNote" #stepNote="ngModel">
          </ion-textarea>
          <ion-icon *ngIf="step.padLock" style="padding: 9px;" name="lock-closed-outline"  color="success" (click)="step.padLock=false"></ion-icon>
          <ion-icon *ngIf="!step.padLock" style="padding: 9px;" name="lock-open-outline"  color="danger"   (click)="step.padLock=true"></ion-icon>
        </ion-item>
      </div>
      <ion-list class="radio-list" >
        <ion-radio-group [(ngModel)]="step.compliance" name="compliance" #compliance="ngModel"
          (ionChange)="checkComplianceType(step.compliance)">
          <ion-row>
            <ion-col size="3">
              <ion-item lines='none'>
                <ion-label class="coccc-radio-title"> {{ 'Yes, Compliant' | translate}}</ion-label>
                <ion-radio mode='md' item-left slot="start" [disabled]="!step.stepBody  || this.isRiskReassessment || (this.roadmapStatus ==='Completed' && this.isCustom === 'false')" value="yesCompliant"
                  class="coccc-circle-style">
                </ion-radio>
              </ion-item>
            </ion-col>
            <ion-col size="3">
              <ion-item lines='none'>
                <ion-label class="coccc-radio-title"> {{ 'Not applicable' | translate}}</ion-label>
                <ion-radio mode='md' item-left slot="start" [disabled]="!step.stepBody  || this.isRiskReassessment || (this.roadmapStatus ==='Completed' && this.isCustom === 'false')" value="notApplicable"
                  class="coccc-circle-style">
                </ion-radio>
              </ion-item>
            </ion-col>
            <ion-col size="3">
              <ion-item lines='none'>
                <ion-label class="coccc-radio-title"> {{ 'Report Hazard' | translate}}</ion-label>
                <ion-radio mode='md' item-left slot="start" [disabled]="!step.stepBody  || this.isRiskReassessment || (this.roadmapStatus ==='Completed' && this.isCustom === 'false')" value="hazard"
                  class="coccc-circle-style">
                </ion-radio>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-text style="font-size: x-small; font-weight: bold" *ngIf="compliance.invalid && compliance.touched"
            color="danger">
            Required
          </ion-text>
        </ion-radio-group>
        <ion-button class="app-large-btn add-hazard-btn" shape="round" fill="outline" color="primary"
          [disabled]="(this.roadmapStatus ==='Completed' && this.isCustom === 'false')||(step.compliance!=='hazard')" skipLocationChange (click)='addHazardDetails(i,step)'>
          {{'Add Hazard Details'|translate}}
        </ion-button>
      </ion-list>
     
      <div *ngIf="step.compliance==='yesCompliant' && step.isListItemOpened">
        <ion-row>
          <ion-col size="12" class="upload-img">{{'Upload Images' | translate}} </ion-col>
          <ion-col size="1" *ngIf="this.roadmapStatus!=='Completed'">
            <input style="display: none;" type="file" accept=".png,.jpeg,.jpg" #complaintImage [id]="'file-inp' + subSectionIndex + '#'  + i"
              (change)="uploadFile($event,step,i,complaintImage)" />
            <label [for]="'file-inp' + subSectionIndex + '#' + i">
              <div class="upload-div">
                <ion-icon slot="start" name="add-circle-outline"></ion-icon>
              </div>
            </label>
          </ion-col>
          <ion-col size="12">
            <ion-row>
              <ion-col size="4" *ngFor="let eachImg of step.previewImages;let i=index">
                <ion-list class="machineLimitsPreview" style="width: auto;">
                  <div style="position:relative; width:'mainimagewidth'">
                    <img [src]="eachImg.img" alt="" style="height: 8rem;width:90%;margin-right: -22px;" alt="" />
                    <span style="position:absolute; top:0;" *ngIf="this.roadmapStatus!=='Completed'">
                      <ion-icon name="close-circle-outline" style="font-size: x-large;"
                        (click)="deleteImage(eachImg,step.previewImages,i)"></ion-icon>
                    </span>
                  </div>
                </ion-list>

              </ion-col>
              <ion-col size="12" style="padding-left: 20px;" *ngIf="step?.hasOwnProperty('answers')">
                <ion-row>
                  <ion-col size="4" *ngFor="let each of step?.answers[0]?.complaintMedia;let i=index">
                    <div *ngIf="each.imgUrl" style="position:relative; width:'mainimagewidth'">
                      <img [src]="each.imgUrl" alt="" style="height: 8rem;width:90%;margin-right: -22px;" alt="" />
                      <span style="position:absolute; top:0;" *ngIf="this.roadmapStatus!=='Completed'">
                        <ion-icon name="close-circle-outline" style="font-size: x-large;"
                          (click)="deleteImage(each,step?.answers[0]?.complaintMedia,i)"></ion-icon>
                      </span>
                    </div>
                  </ion-col>
                </ion-row>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
      </div>
      <div *ngIf="step.hazardCount!=0 && step?.answers && step?.answers[0]?.hazardDetails">
        <div class="table_wrapper">
          <div class="tableFixHead">
            <table class="table">
              <thead>
                <th class="text th" style="position: sticky; left: 0; z-index: 3;background: #f0f4fb;"> {{ 'Hazard Name'|translate}}
                </th>
              </thead>
              <tr *ngFor="let answer of step?.answers">
                <td class="td hazard-detail"  *ngFor="let eachHazard of answer?.hazardDetails"
                  (click)="editHazard(eachHazard,step)">
                  <span>{{eachHazard?.name}}</span>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>

    </div>
  </form>
</div>